import type { SVGProps } from 'react';

const SvgLineText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.839 2.067a1.88 1.88 0 0 1 1.88 1.88V5.16a.5.5 0 0 1-1 0V3.947a.88.88 0 0 0-.88-.88H8.495q.004.026.005.053v10.574h2.126l.101.01a.5.5 0 0 1 0 .98l-.101.01H5.373a.5.5 0 0 1 0-1H7.5V3.12q.001-.027.005-.053H3.159a.88.88 0 0 0-.88.88V5.16a.5.5 0 0 1-1 0V3.947c0-1.045.846-1.88 1.88-1.88z'
      fill='#3889FF'
    />
  </svg>
);
export default SvgLineText;
